/** @format */

export const END_LOADING = "END_LOADING";
export const START_LOADING = "START_LOADING";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
//Attendance .........
export const POST_ATTENDANCE = "POST_ATTENDANCE";
export const GET_ATTENDANCE = "GET_ATTENDANCE";
export const GET_DETAIL_TO_ADMIN = "GET_DETAIL_TO_ADMIN";
export const FETCH_LIST_TO_FACULTY = "FETCH_LIST_TO_FACULTY";
export const UPDATE_STUDENT = "UPDATE_STUDENT";
export const EXPIRE_SUBJECT = "EXPIRE_SUBJECT";
export const UPDATE_TIME = "UPDATE_TIME";
//COLLEGE .........

export const ADD_COLLEGE = "ADD_COLLEGE";
export const ADD_INITIAL_ADMIN = "ADD_INITIAL_ADMIN";
export const GET_COLLEGE_DATA = "GET_COLLEGE_DATA";
export const FETCH_ALL_COLLEGE = "FETCH_ALL_COLLEGE";

//FACULTY......

export const SIGNIN_FACULTY = "SIGNIN_FACULTY";
export const SIGNUP_FACULTY = "SIGNUP_FACULTY";
export const GET_FACULTY = "GET_FACULTY";
export const REMOVE_FACULTY = "REMOVE_FACULTY";
export const MAKE_ADMIN = "MAKE_ADMIN";
export const REMOVE_ADMIN = "REMOVE_ADMIN";

//STUDENT.....

export const SIGNIN_STUDENT = "SIGNIN_STUDENT";
export const SIGNUP_STUDENT = "SIGNUP_STUDENT";
export const GET_DATA_TO_STUDENT = "GET_DATA_TO_STUDENT";

export const RESET_STUDENT = "RESET_STUDENT";

export const SET_COLLEGE_ID = "SET_COLLEGE_ID";

export const SUBJECT_LIST = "SUBJECT_LIST";
